<template>
    <div>
        <Card dis-hover :bordered="false">
            <Row>
                <Col span="12">
                    <h3 v-if="!readonly">{{$t('route.intercourseReconciliationsAdd')}}</h3>
                    <h3 v-else>{{$t('intercourse.t24')}}</h3>
                </Col>
                <Col span="12">
                    <Steps :current="step">
                        <Step :title="$t('fpzInvaccCommon.t1')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t2')"></Step>
                        <Step :title="$t('fpzInvaccCommon.t3')"></Step>
                    </Steps>
                </Col>
            </Row>
        </Card>
        <Card >
            <Form ref="formHeader" :model="invaccHeader" :label-width="90" :rules="ruleValidate">
              <Row>
                <Col span="8" push="0">
                <!-- 买方 -->
                    <FormItem :label="$t('intercourse.t1')" prop="orgId">
                        <Select v-model="invaccHeader.orgId" :disabled="readonly" @on-change="orgOnChange">
                            <Option v-for="item in ouList" :value="item.value" :key="item.value">{{ item.label
                            }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8" push="0">
                <!-- 币种 -->
                    <FormItem :label="$t('intercourse.t7')" :required="true" prop="currencyCode">
                        <Select v-model="invaccHeader.currencyCode" :disabled="readonly">
                            <Option v-for="item in currencyCodeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8" push="0">
                <!-- 截止期间 -->
                    <FormItem :label="$t('intercourse.t19')" :required="true">
                      <Row :gutter="0">
                        <FormItem prop="periodNameGsc">
                                <Input type="text" placeholder="" :readonly="true" :disabled="readonly" v-model="invaccHeader.periodNameGsc">
                                    <Button slot="append" icon="ios-search" :disabled="readonly || !invaccHeader.orgId" @click="showCustomDate('start')"></Button>
                                </Input>
                            </FormItem>
                      </Row>
                    </FormItem>
                    </Col>
              </Row>
              <Row>
                <Col span="8" push="0">
                <!-- 期末金额 -->
                    <FormItem :label="$t('intercourse.t8')">
                        <InputNumber :disabled="true" v-model="invaccHeader.endBalanceAmt">
                        </InputNumber>
                    </FormItem>
                </Col>
                <Col span="8" push="0">
                    <FormItem :label="$t('commonTw.t2')">
                        {{doStatus()}}
                    </FormItem>
                </Col>
              </Row>
    
              <Row type="flex" justify="center">
                <Col>
                    <Button v-if="!readonly" type="primary" class="mr8" @click="search" :loading="loading">
                        {{$t('common.queryBtn')}}
                      </Button>
                      <Button v-if="!readonly" type="ghost" class="mr8" @click="$refs['formHeader'].resetFields();">
                        {{$t('common.clearBtn')}}
                      </Button>
                      <Button v-if="!readonly" type="primary" class="mr8" @click="save" :loading="loading">
                        {{$t('common.saveBtn')}}
                      </Button>
                      <Button type="primary" class="mr8" @click="goBack">{{$t('common.back')}}</Button>
                </Col>
              </Row>
            </Form>
        </Card>
        <m-assembly-table ref='pageForm'
            :columns='summaryModule.columns'
            :data='summaryModule.tableData'
            :tableButtons='summaryModule.tableButtons'
            :loading='loading'
            :currentPage='summaryModule.settings.currentPage'
            :pageSize='summaryModule.settings.pageSize'
            :total='summaryModule.settings.total'
            :settings='summaryModule.settings'
            @onPageSizeChange='summaryOnPageSizeChange'
            @onCurrentPageChange='summaryOnPageChange'
        >
        </m-assembly-table>
        <Modal v-model="dateModal.show"
            title=" "
                :width="800">
            <m-assembly-table ref='pageForm'
                v-if="dateModal.show"
                :columns='dateModal.columns'
                :data='dateModal.tableData'
                :loading='loading'
                :currentPage='dateModal.settings.currentPage'
                :pageSize='dateModal.settings.pageSize'
                :total='dateModal.settings.total'
                :settings='dateModal.settings'
                :height="500"
                @onRowClick="dateOnRowClick"
            >
            </m-assembly-table>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {getOuList, queryList} from './financialAccounting';
import axios from 'axios';
export default {
    components: {
        mAssemblyTable,
    },
    props: {
        // readonly: {
        //     type: Boolean,
        //     default: false
        // },
        hideTable: {
            type: Boolean,
            default: false
        }
    },
    data () {
        const validateDate = (rule, value, callback) => {
            if (value < this.invaccHeader.periodFrom) {
            callback(new Error(this.$t('fpzInvaccCommon.t4')));
            } else {
            callback();
            }
        };
        return {
            readonly: true,
            step: 0,
            invaccDetailTabs: '',
            itemId: '',
            headerId: '',
            periodFlag: '',
            invaccHeader: {
                orgId: '',
                currencyCode: '',
                periodNameGsc: '',
                endBalanceAmt: 0
            },
            ruleValidate: {
                orgId: [{required: true, message: this.$t('intercourse.t27')}],
                periodNameGsc: [{required: true, message: this.$t('intercourse.t27'), trigger: 'blur'}],
                currencyCode: [{required: true, message: this.$t('intercourse.t27'), trigger: 'blur'}],
                // periodTo: [{required: true, message: this.$t('common.isRequired'), trigger: 'blur'}, {validator: validateDate, trigger: 'blur'}]
            },
            orgList: [],
            currencyCodeList: [],
            loading: false,
            summaryModule: {
                columns: {
                    columns: [
                        {
                            title: this.$t('intercourse.t14'), // 日期
                            align: 'center',
                            key: 'invoiceDate',
                            minWidth: 180
                        },
                        {
                            title: this.$t('intercourse.t26'), // GL日期
                            align: 'center',
                            key: 'glDate',
                            minWidth: 180
                        },
                        {
                            title: this.$t('intercourse.t23'), // 发票类型
                            align: 'center',
                            key: 'invoiceType',
                            tooltip: true,
                            minWidth: 300,
                            render: (h, params) => {
                                const data = this.INT_GSC_INVOICE_TYPE.find(item => item.value == params.row.invoiceType);
                                return h('span', {}, data.label); 
                            },
                        },
                        {
                            title: this.$t('intercourse.t15'), // 发票号
                            align: 'center',
                            key: 'invoiceNum',
                            minWidth: 120
                        },
                        {
                            title: this.$t('intercourse.t16'), // 原始金额
                            align: 'center',
                            key: 'originalAmount',
                            minWidth: 120
                        },
                        {
                            title: this.$t('intercourse.t17'), // 发票金额
                            align: 'center',
                            key: 'balanceAmount',
                            minWidth: 120
                        },
                        {
                            title: this.$t('intercourse.t18'), // 备注
                            align: 'center',
                            key: 'remarks',
                            minWidth: 120
                        },
                    ]
                },
                tableData: [],
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('common.export'),
                            type: 'primary',
                            icon: 'archive',
                            loading: false,
                            disabled: false,
                            size: 'small',
                            click: (button) => {
                                this.$set(button, 'loading', true);
                                let paraJson = {
                                    "orgId": this.invaccHeader.orgId,
                                    "vendorCode": this.vendorCode,
                                    "periodNameGsc": this.invaccHeader.periodNameGsc,
                                    "currencyCode": this.invaccHeader.currencyCode,
                                    "language": this.$i18n.locale == 'zh-CN' ? 'zh-CN' : 'en-US'
                                }
                                axios({
                                    url: '/gscint/bill/exportDetail',
                                    method: 'post',
                                    responseType: 'blob',
                                    data: paraJson
                                }).then((res) => {
                                    this.$set(button, 'loading', false);
                                    console.log('this.$i18n.locale', this.$i18n.locale);
                                    this.downloadFile(res.data, this.$i18n.locale == 'zh-CN' ? '往来对账明细.xlsx' : 'BillDetail.xlsx');
                                })
                                .catch(() => {
                                    this.showErrorTips();
                                });
                            }
                        }
                    ]
                },
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            statusList: [],
            dateModal: {
                show: false,
                columns: {
                    columns: [
                        {
                            title: this.$t('fpzInvaccCommon.t33'), // 序号
                            type: 'index',
                            width: 60,
                            align: 'center'
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t34'), // 月份
                            key: 'periodNumber',
                            align: 'center',
                            minWidth: 140
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t35'), // 开始日期
                            key: 'startDate',
                            align: 'center',
                            minWidth: 257
                        },
                        {
                            title: this.$t('fpzInvaccCommon.t36'), // 截止日期
                            key: 'endDate',
                            align: 'center',
                            minWidth: 258
                        }
                    ]
                },
                tableData: [
                    {}
                ],
                settings: {
                    needPager: false,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            ouList: [],
            INT_GSC_INVOICE_TYPE: [],
            canSearch: true
        }
    },
    methods: {
        doStatus() {
            let row = this.statusList.find(item => item.value == (this.invaccHeader.billStatus || 'NEW'));
            if(row) {
                return row.label;
            }
        },
        getDetail() {
            axios.get('/gscint/bill/billDetail', {
                params: {
                    headerId: this.headerId
                }
            })
            .then((resp) => {
                let res = resp.data.data;
                this.readonly = true;
                // this.invaccHeader = res.datas.header;
                res.datas.header.periodNameGsc = res.datas.header.endPeriodName;
                res.datas.header.orgId = res.datas.header.orgId + '';
                this.invaccHeader = res.datas.header;
                this.summaryModule.tableData = res.datas.lineList;
                let stepObj = {
                    'NEW': 1,
                    'REJECT': 1,
                    'VCONFIRM': 2,
                    'CLOSED': 3
                }
                this.step = stepObj[this.invaccHeader.billStatus];
            });
        },
        /* 组织选择 */
        orgOnChange (val) {
            if (!this.headerId) {
                this.invaccHeader.endBalanceAmt = 0;
                this.summaryModule.tableData = [];
            }
            if (val) {
                // this.invaccHeader.organizationId = this.orgList.find((item) => item.value === val).erpOrgId;
                if(!this.headerId) {
                    this.dateSearch('start');
                    // const orgId = this.invaccHeader.orgId;
                    axios.get('/gscint/hwVendorAccounter/hasValidAccounter', {
                        params: {
                            vendorCode: this.vendorCode,
                            ouId: val
                        }
                    })
                    .then((resp) => {
                        let res = resp.data.data;
                        console.log('res---', res)
                        if(res.code != 1) {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: this.$t('intercourse.t25'),
                            });
                            this.canSearch = false;
                        } else {
                            this.canSearch = true;
                        }
                    });
                }
            }
        },
        showCustomDate (type) {
            this.dateModal.show = true;
            this.dateSearch(type);
        },
        fromValidate () {
            let flag = false;
            this.$refs.formHeader.validate((valid) => {
                flag = valid;
            });
            return flag;
        },
        /* 新建查询 */
        async search () {
            if (this.fromValidate()) {
                if(this.canSearch) {
                    this.summaryModule.settings.currentPage = 1;
                    this.queryItemList('/gscint/bill/queryIapBalanceDetail');
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('intercourse.t25'),
                    });
                }
            }
        },
        async queryItemList (url) {
            let {
                currentPage, pageSize
            } = this.summaryModule.settings;
            this.loading = true;
            let params = {
                ...this.invaccHeader,
                vendorCode: this.vendorCode,
            };
            axios.post(url, params)
            .then((res) => {
                this.loading = false;
                let {success, msg, datas} = res.data.data;
                if (success) {
                    console.log('ls', datas)
                    this.summaryModule.tableData = datas;
                    let count = 0;
                    datas.forEach(item => {
                        count += item.balanceAmount;
                    });
                    this.invaccHeader.endBalanceAmt = count.toFixed(2);
                } else {
                    this.$Modal.error({
                        content: msg || (data && data.message)
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        async summaryList (url) {
            let {
                currentPage, pageSize
            } = this.summaryModule.settings;
            this.loading = true;
            await queryList(url, {
                ...this.invaccHeader,
                vendorCode: this.vendorCode,
                pageNum: currentPage,
                pageSize
            }, this)
            .then(({list, total}) => {
                this.summaryModule.tableData = list;
                this.summaryModule.settings.total = total;
            });
            this.loading = false;
        },
        /* 保存 */
        save () {
            this.$refs.formHeader.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const { orgId, currencyCode, periodNameGsc: endPeriodName, endBalanceAmt } = this.invaccHeader;
                    axios.post('/gscint/bill/createBill', {
                        vendorCode: this.vendorCode,
                        vendorId: this.vendorId,
                        orgId,
                        currencyCode,
                        endPeriodName,
                        endBalanceAmt,
                    })
                        .then((res) => {
                            this.loading = false;
                            const { success, msg, code } = res.data.data;
                            if (success && code == 1) {
                                this.$Modal.success({
                                    content: this.$t('common.save_success'),
                                });
                                this.$closeTab({
                                    name: 'intercourseReconciliationsAdd',
                                });
                            } else {
                                this.$Modal.error({
                                    content: msg,
                                });
                            }
                        })
                        .catch(() => {
                            this.showErrorTips();
                        });
                }
            });
        },
        goBack () {
            this.$router.push({
                name: 'intercourseReconciliationsSearch'
            });
        },
        // detailOnPageSizeChange (pageNum, pageSize) {
        //     if (this.fromValidate()) {
        //         this.detailModule.settings.currentPage = 1;
        //         this.detailModule.settings.pageSize = pageSize;
        //         queryLineTrcs(this, this.headerId, this.itemId, this.headerId ? 'detail' : 'new');
        //     };
        // },
        // detailOnPageChange (pageNum, pageSize) {
        //     if (this.fromValidate()) {
        //         this.detailModule.settings.currentPage = pageNum;
        //         queryLineTrcs(this, this.headerId, this.itemId, this.headerId ? 'detail' : 'new');
        //     }
        // },
        /* 期间查询 */
        dateSearch (periodFlag) {
            this.periodFlag = periodFlag;
            axios.post('/gscint/hw/invacc/getPeriodDate', {
                module: 'AP',
                orgId: this.invaccHeader.orgId,
                vendorCode: this.vendorCode,
                // vendorSiteCode: this.invaccHeader.vendorSiteCode,
                status: 'Closed',
            })
            .then((res) => {
                this.loading = false;
                let {success, data, message} = res.data.data;
                // debugger
                console.log('res.data.data', res.data.data)
                if (success) {
                    this.dateModal.tableData = data || [];
                    if (data.length) {
                        this.invaccHeader.periodNameGsc = data[data.length - 1].periodNameGsc;
                    } else {
                        this.invaccHeader.periodNameGsc = '';
                    }
                } else {
                    this.$Modal.error({
                        content: message
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 日期选择 */
        dateOnRowClick (row) {
            this.dateModal.show = false;
            this.invaccHeader.periodNameGsc = row.periodNameGsc;
        },
        summaryOnPageSizeChange (pageNum, pageSize) {
            this.summaryModule.settings.currentPage = 1;
            this.summaryModule.settings.pageSize = pageSize;
            this.summaryList('/gscint/hw/invacc/queryLinesSummary');
        },
        summaryOnPageChange (pageNum, pageSize) {
            this.summaryModule.settings.currentPage = pageNum;
            this.summaryList('/gscint/hw/invacc/queryLinesSummary');
        },
        transactionOnPageSizeChange (pageNum, pageSize) {
            this.transactionModule.settings.currentPage = 1;
            this.transactionModule.settings.pageSize = pageSize;
            this.queryItemList(this.headerId ? '/gscint/hw/invacc/queryLines' : '/gscint/hw/invacc/queryTransactions');
            
        },
        transactionOnPageChange (pageNum, pageSize) {
            this.transactionModule.settings.currentPage = pageNum;
            this.queryItemList(this.headerId ? '/gscint/hw/invacc/queryLines' : '/gscint/hw/invacc/queryTransactions');
        },
        init () {
            if (!this.hideTable) {
                getOuList((data) => {
                    console.log('data', data)
                    this.ouList = data;
                    // this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data;
                });
                this.getDict('INT_RECONCILIATION_STATUS', (data) => {
                    this.statusList = data;
                });
                this.getDict('INT_CURRENCY', (data) => {
                    console.log('data', data);
                    this.currencyCodeList = data;
                    // this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data;
                });
                this.getDict('INT_GSC_INVOICE_TYPE', (data) => {
                    console.log('data', data);
                    let arr = [];
                    data.forEach(item => {
                        if(this.$i18n.locale != 'zh-CN') {
                            item.label == item.valueEn || item.label;
                            arr.push(item);
                        } else {
                            arr.push(item);
                        }

                    })
                    this.INT_GSC_INVOICE_TYPE = arr;
                    // this.getFormDataItemObj(this.formData.items, 'organizationCode').options.values = data;
                });
                this.headerId = this.$route.query.id;
                if (this.headerId) {
                    this.getDetail();
                } else {
                    this.readonly = false;
                }
            }
        },
    },
    mounted() {
        this.init();
    },
    activated() {
        this.init();
    },
}

</script>
<style lang="less" scoped>
.mr8 {
    margin-right: 8px;
}
/deep/ .m-date-picker{
    width: 100%;
}
/deep/ .m-input-number{
    width: 100%;
}
/deep/ .m-select-selected-value, /deep/ .m-input-number-disabled .m-input-number-input, /deep/ .m-input[disabled] {
    color: #666;
    opacity: 1;
}
</style>